import React from 'react';
import { T } from '@tribeplatform/react-components/i18n';
import { useBlock } from '@tribeplatform/react-slate-kit/hooks';
import { Alert } from '@tribeplatform/react-ui-kit/Alert';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
export const HighlightedTagsBlockSettings = () => {
    const { block: { props: { title }, }, upsertProp, } = useBlock();
    return (React.createElement("div", { className: "space-y-5" },
        React.createElement(FormControl.Input, { name: "title", label: React.createElement(T, { id: "Generics.Title", defaultMessage: "Title" }), value: title, onChange: e => upsertProp('title', e.target.value) }),
        React.createElement(Alert, { status: "info" },
            React.createElement(T, { id: "Blocks.HighlightedTags.LegacyInfoText", defaultMessage: "Highlighted tags is a legacy block. We recommend using the new and improved <strong>{TAGS_CC}</strong> block instead." }))));
};
//# sourceMappingURL=Settings.js.map